<div class="spinner d-flex align-items-center justify-content-center">
	<div class="overlay-bg"></div>
</div>